var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper mySwiper"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('div',{staticClass:"img",style:({ backgroundImage: ("url(" + (item.Img) + ")") }),on:{"click":function($event){_vm.imgClick(item)}}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-549f4edc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/carousel/swiper_publication.vue
// module id = null
// module chunks = 